export default __webpack_public_path__ + "static/media/old_logo_black.019a27f263461dc34a5e4afe855749e6.svg";